import { serverBus } from '@/main';
import { API } from '@/inc/api';

export const status = {
    namespaced: true,
    state: {
        status      : [],
        needRefresh : true,
    },
    mutations: {
        setStatus( state, payload ) {
            state.status = payload;
        },
        setNeedRefresh( state, payload ) {
            state.needRefresh = payload;
        }
    },
    actions: {
        async load({ commit, state }) {
            if( !state.needRefresh ) {
                return Promise.resolve();
            }

            try {
                let api = new API();
                let res = await api.get('/admin/status');

                if( !res.data.status ) {
                    serverBus.$emit('alert', { 
                        text    : res.data.message, 
                        color   : res.data.error ? 'error' : 'warning'
                    });
                    return Promise.reject( false );
                }

                commit('setStatus', res.data.data);
                commit('setNeedRefresh', false);
                return Promise.resolve();
            }
            catch(error) {
                return Promise.reject(error);
            }
        },
        setNeedRefresh({ commit }, payload) {
            commit('setNeedRefresh', payload);
        }
    },
    getters: {
        status      : (state) => state.status,
        needRefresh : (state) => state.needRefresh
    }
}